import { render, staticRenderFns } from "./listAllCustomers.vue?vue&type=template&id=3a4e49de&scoped=true"
import script from "./listAllCustomers.vue?vue&type=script&lang=ts"
export * from "./listAllCustomers.vue?vue&type=script&lang=ts"
import style0 from "./listAllCustomers.vue?vue&type=style&index=0&id=3a4e49de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e49de",
  null
  
)

export default component.exports